<template lang="pug">
pr-wrapper.cms-layout(fs, bg, :bgo="background_ ? (hasOverlay ? '.6' : '0') : '1'")
  sidepane(v-if="sidepane_", :payload="sidepane_", @close="sidepane_ = $event", @cart="addToCart")
  pr-wrapper.infobar-container.p-5(fs)
    info-bar(scope="cms-infobar", data-down="cms-scope")
  .cms-layout-container(v-nv:scope="'cms-scope'", :class="{ hasOne: hasOne_ }", @nv-up="up", @nv-down="down")
    row.cms-layout-row(
      :navigate="index ? false : true",
      :carousel="content",
      :key="index",
      v-for="(content, index) in contents_",
      @sidepane="sidepane_ = $event",
      @close="() => $emit('close')",
      :cardWidth="cardWidth"
    )
</template>

<script>
import sidepane from "../details/sidepane.vue"
import row from "./row.vue"
export default {
  name: "cms-layout",
  components: { row, sidepane },
  props: ["contents", "background", "cardWidth", "prevRoute"],
  data() {
    return {
      activate_: false,
      sidepane_: null,
      activeRow_: 0
    }
  },
  computed: {
    contents_() {
      if (this.contents.length < 2) return this.contents

      const res = this.contents.slice(this.activeRow_, this.activeRow_ + 2)
      if (res.length < 2) return res.concat(this.contents.slice(0, 2 - res.length))
      return res
    },
    hasOne_() {
      return this.contents.length === 1
    },
    hasOverlay() {
      if (!this.hasOne_) return false
      return _$.true(this.contents[0]?.overlay)
    },
    background_() {
      return !this.hasOne_ ? false : this.background || this.contents[0]?.background || false
    }
  },
  watch: {
    contents_(nval, oval) {
      if (!oval.length) return
      if (["cms-scope", "cms-infobar"].includes(_$.nav.currentScopeName())) this.$nextTick().then(() => _$.nav.sync("cms-scope", true))
    },
    sidepane_(nval, oval) {
      if (this._inactive) return
      if (oval && !nval) {
        __.common.tvWindowBehind()
        _$.nav.changeScope("cms-scope")
        this.initBackground()
      }
    }
  },
  deactivated() {
    this.sidepane_ = null
    this.activate_ = true
  },
  async activated() {
    if (!this.activate_) return

    await this.$nextTick()
    if (!this.prevRoute?.startsWith("/cms")) this.activeRow_ = 0

    await this.$nextTick()
    this.init()
  },
  async mounted() {
    await this.$nextTick()
    this.init()
  },
  methods: {
    async init() {
      if (this.prevRoute?.startsWith("/cms")) {
        _$.nav.changeScope("cms-scope")
        return this.initBackground()
      } else return _$.nav.sync("cms-scope", true).then(res => res && this.initBackground())
    },
    up() {
      if (!this.activeRow_) return _$.nav.changeScope("cms-infobar")
      else this.activeRow_--
    },
    down() {
      if (this.activeRow_ >= this.contents.length - 1) this.activeRow_ = 0
      else this.activeRow_++
    },
    initBackground() {
      if (!this.background_) return true

      const ext = this.background_.split(".").pop()
      if (["jpg", "jpeg", "png", "gif"].indexOf(ext.toLowerCase()) !== -1) __.platform.background(this.background_?.host())
      else if (["mp4", "avi", "ts", "mkv"].indexOf(ext.toLowerCase()) !== -1) __.media.play(this.background_?.host(), true)
      return true
    },
    async addToCart(payload) {
      if (this.sidepane_) {
        this.sidepane_ = null
        await this.$nextTick()
      }

      __.order.add(payload)
    }
  }
}
</script>

<style lang="scss" scoped>
.infobar-container {
  bottom: auto !important;
  display: flex;
  justify-content: flex-end;
}

.cms-layout-container {
  &.hasOne {
    position: absolute;
    bottom: 0;
  }
}
</style>
